import TableDocs from "./TableDocs";
import Modal from "./Modal";

const BigFlipRequiredDocs = (): null => null;

BigFlipRequiredDocs.Table = TableDocs;
BigFlipRequiredDocs.Modal = Modal;

export default BigFlipRequiredDocs;
